import { Environment } from './environment';

export const IS_DEV = process.env.NODE_ENV === Environment.development;

export const BASE_URL = process.env.BASE_URL ?? 'http://localhost:3000';

export const ADMIN_ENABLED = process.env.ADMIN_DASHBOARD_ENABLED === 'true';
